import { render } from "./intercom-section.vue?vue&type=template&id=baaac194"
import script from "./intercom-section.vue?vue&type=script&lang=js"
export * from "./intercom-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__